import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { canAccess, getDefaultRoute } from 'utils/roleAccess';
import type { AppSection } from 'utils/roleAccess';

interface Props {
  /** The section this route belongs to */
  section: AppSection;
  children: React.ReactNode;
}

/**
 * Guard that checks role-based access for a top-level section.
 * Redirects to the user's default landing page when access is denied.
 */
const RouteGuard: React.FC<Props> = ({ section, children }) => {
  const { auth } = useAuth();

  // Wait until user profile is fully loaded
  if (auth.isLoading || !auth.user || !auth.user.accountProfile) {
    return null;
  }

  if (!canAccess(auth.user, section)) {
    return <Navigate to={getDefaultRoute(auth.user)} replace />;
  }

  return <>{children}</>;
};

export default RouteGuard;
